import React from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { setRegisterOptions } from '../../store/actions';

function ChangeRegistrationTypeLink(props) {
  const { t } = useTranslation();
  const { primary, propsClassName } = { ...props };

  const replaceLinkTextPrimary = {
    color: `${primary}`,
  };

  const handleChangeRegistrationType = () => {
    props.setRegisterOptions(null);
  };

  const mainContent = (
    <div
      className={classNames({
        'change-registration': true,
        [propsClassName]: propsClassName,
      })}
      onClick={() => {
        handleChangeRegistrationType();
      }}
      onKeyPress={(e) => {
        if (['Enter'].includes(e.key)) {
          handleChangeRegistrationType();
        }
      }}
      tabIndex={0}
      role="button"
      aria-label="change registration type by clicking here"
    >
      <div className="change-registration--caret">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17.409 10.565">
          <path
            className="a"
            fill={primary}
            d="M13.684,133.779l-7.748-7.748a.957.957,0,0,1,0-1.353l.9-.9a.957.957,0,0,1,1.351,0l6.169,6.14,6.169-6.14a.957.957,0,0,1,1.351,0l.9.9a.957.957,0,0,1,0,1.353l-7.748,7.748A.957.957,0,0,1,13.684,133.779Z"
            transform="translate(-5.656 -123.494)"
          />
        </svg>
      </div>
      <button
        className="change-registration--link"
        data-cy="change-registration--link"
        onClick={() => {
          handleChangeRegistrationType();
        }}
        onKeyPress={(e) => {
          if (['Enter'].includes(e.key)) {
            handleChangeRegistrationType();
          }
        }}
        type="button"
        tabIndex={0}
        style={replaceLinkTextPrimary}
      >
        {t('Change Registration Type')}
      </button>
    </div>
  );

  return mainContent;
}

export default connect(null, { setRegisterOptions })(
  ChangeRegistrationTypeLink
);
